import { faBed, faBroom, faCalendarCheck, faCalendarDay, faChartPie, faSackXmark } from "@fortawesome/free-solid-svg-icons";
import TabNav from "components/common/tabs/TabNav";
import TabNavLink from "components/common/tabs/TabNavLink";
import { AppRoutes, URI_PARAMETER_KEYS } from "config/router";
import { Outlet, useParams } from "react-router-dom";
import { Roles } from "utilities/app-utilities";
import useAppContext from "utilities/hooks/useAppContext";

const AccommodationSeasonOverviewPage = () => {
    const context = useAppContext();
    const { [URI_PARAMETER_KEYS.TARGET_SEASON_ID]: targetSeasonId } = useParams<{ [URI_PARAMETER_KEYS.TARGET_SEASON_ID]: string }>();
    const queryParams: Record<string, any> | undefined = {
        [URI_PARAMETER_KEYS.TARGET_SEASON_ID]: targetSeasonId
    }

    return (
        <div className="accommodation-page app-tabs">
            <TabNav alt>
                <TabNavLink
                    to={AppRoutes.ACCOMMODATION_SEASON_OVERVIEW_HOME}
                    params={queryParams}
                    text="pages.accommodation.booking.list"
                    icon={faBed}
                    hidden={!context.userHasRole(Roles.ACCOMMODATION_BOOKINGS_READ)}
                />
                <TabNavLink
                    to={AppRoutes.ACCOMMODATION_SEASON_OVERVIEW_MAINTENANCE}
                    params={queryParams}
                    text="pages.accommodation.work.maintenance.list"
                    icon={faBroom}
                    hidden={!context.userHasRole(Roles.ACCOMMODATION_WORK_READ)}
                />
                <TabNavLink
                    to={AppRoutes.ACCOMMODATION_SEASON_OVERVIEW_INVESTMENT}
                    params={queryParams}
                    text="pages.accommodation.work.investment.list"
                    icon={faSackXmark}
                    hidden={!context.userHasRole(Roles.ACCOMMODATION_WORK_READ)}
                />
                <TabNavLink
                    to={AppRoutes.ACCOMMODATION_SEASON_OVERVIEW_OVERVIEW}
                    params={queryParams}
                    text="pages.overview"
                    icon={faChartPie}
                    hidden={!context.userHasRole(Roles.ACCOMMODATION_BOOKINGS_READ)}
                />
            </TabNav>
            <Outlet />
        </div>
    );
};

export default AccommodationSeasonOverviewPage;
